<mobile-page-part noContentMessage="No Calendar Events Found">

	<div class="info-content" style="min-width: 210px;">
		<small>[Event Type Selector Goes Here]</small>
	</div>

</mobile-page-part>